import {
  superManagersList,
  userhierarchy,
} from "../../../../backoffice/src/js/api/reports.js";
import {
  getAdminUsers,
  getJackPotValue,
  jackpotTransfer,
} from "../../js/api/jackpot.js";
import { _t } from "../../services/TranslationService.js";

let userId = 0;
let jackpotValue;
let Jackpot = {
  render: async () => {
    jackpotValue = await getJackPotValue();
    let view = /*html*/ `
        <div class="jackpotHolder">
        <div class="usersHeader m-t-6">
                 <span>${_t('Jackpot')}</span>
           </div>
           <div class="jackpotRow">
           <span>${_t('Jackpot value (casino):')}</span>
           <span>${parseFloat(jackpotValue.actual_jackpot).toFixed(2)}</span>
           </div>
           <div class="jackpotRow">
           <span>${_t('Jackpot value (live):')}</span>
           <span>${parseFloat(jackpotValue.actual_jackpot_live).toFixed(
             2
           )}</span>
           </div>
           <div class="jackpotRow">
           <span>${_t('Jackpot value (prematch):')}</span>
           <span>${parseFloat(jackpotValue.actual_jackpot_prematch).toFixed(
             2
           )}</span>
           </div>
          <div class="gameBoxHolder">
              <span>${_t('Zgjedh supermenagjerin:')}</span>
              <select class="ticketBoxFilter jackpotSelect" id="smSbox"></select>
            </div>
            <div class="gameBoxHolder">
            <span>${_t('Zgjedh menagjerin:')}</span>
            <select class="ticketBoxFilter jackpotSelect" id="mSbox"></select>
          </div>
          <div class="gameBoxHolder">
          <span>${_t('Zgjedh agjentin:')}</span>
          <select class="ticketBoxFilter jackpotSelect" id="aSbox"></select>
        </div>
        <div class="gameBoxHolder">
        <span>${_t('Zgjedh userin:')}</span>
        <select class="ticketBoxFilter jackpotSelect" id="jackpoUser"></select>
      </div>
            <div class="gameBoxHolder">
            <span>${_t('Zgjedh llojin:')}</span>
            <select class="ticketBoxFilter jackpotSelect" id="jackpotType">
              <option value="1">${_t('Prematch')}</option>
              <option value="2">${_t('Live')}</option>
              <option value="3">${_t('Casino')}</option>
            </select>
          </div>
          <a class="loginBtn loginAuthBtn" id="transferJackpot">${_t('Transfero')}</a>
        </div>
        `;
    return view;
  },
  after_render: async (socket) => {
    $("body #transferJackpot").on("click", async function () {
      const sel = document.getElementById("jackpoUser");
      const text = sel.options[sel.selectedIndex].text;

      const selType = document.getElementById("jackpotType");
      const textType = selType.options[selType.selectedIndex].text;
      let value = 0;
      const type = $("#jackpotType").val();

      if (type == "1") {
        value = jackpotValue.actual_jackpot_prematch;
      } else if (type == "2") {
        value = jackpotValue.actual_jackpot_live;
      } else if (type == "3") {
        value = jackpotValue.actual_jackpot;
      }
      $('body #transferJackpot').addClass("disabled");
      let promise = new Promise(function (resolve, reject) {
        socket.emit(
          "notify_jackpot",
          { user_id: $("#jackpoUser").val(), checking: true, username: text },
          async function (isOnline) {
            if (!isOnline) reject();
            resolve();
          }
        );
        setTimeout(function () {
          reject();
        }, 4 * 1000);
      });

      promise.then(
        async function () {
          socket.emit("notify_jackpot", {
            user_id: $("#jackpoUser").val(),
            type: textType,
            value: value,
            username: text,
            released: true,
          });

          const result = await jackpotTransfer(
            $("#jackpoUser").val(),
            $("#jackpotType").val()
          );
          if (result && result.success == "OK") {
            alert(_t("Jackpoti u leshua me suksess"));
          } else {
            alert(
              _t("Gabim gjate leshimit te jackpotit, nuk ka fonde te mjaftushme!")
            );
          }
          $('body #transferJackpot').removeClass("disabled");
        },
        async function () {
          alert(_t("Lojtari nuk eshte online!"));
          $('#transferJackpot').removeClass("disabled");
        }
      );
    });

    renderSuperManagers();

    $("#smSbox").change(function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      userId = $("#smSbox option:selected").val();

      renderManagers(userId);
    });

    $("#mSbox").change(function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      userId = $("#mSbox option:selected").val();

      renderAgents(userId);
    });

    $("#aSbox").change(function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      userId = $("#aSbox option:selected").val();

      renderUsers(userId);
    });
  },
};

async function renderUsers() {
  const users = await userhierarchy(userId);
  $("#jackpoUser").empty().append(`<option>${_t('Zgjidh')}</option>`);
  users.forEach((element) => {
    $("#jackpoUser").append(`<option value="${element.id}">
             ${element.username}
        </option>`);
  });
}

async function renderSuperManagers() {
  const allSms = await superManagersList();
  $("#smSbox").empty().append(`<option>${_t('Zgjidh')}</option>`);

  allSms.forEach((sm) => {
    $("#smSbox").append(`<option value="${sm.id}"> 
       ${sm.username}   
 </option>`);
  });

  $("#mSbox").empty().append(`<option>${_t('Zgjidh')}</option>`);
  $("#aSbox").empty().append(`<option>${_t('Zgjidh')}</option>`);
  $("#jackpoUser").empty().append(`<option>${_t('Zgjidh')}</option>`);
}

async function renderManagers(userId) {
  const allSms = await userhierarchy(userId);
  $("#mSbox").empty().append(`<option>${_t('Zgjidh')}</option>`);
  allSms.forEach((sm) => {
    $("#mSbox").append(`<option value="${sm.id}"> 
       ${sm.username}   
    </option>`);
  });

  $("#aSbox").empty().append(`<option>${_t('Zgjidh')}</option>`);
  $("#jackpoUser").empty().append(`<option>${_t('Zgjidh')}</option>`);
}

async function renderAgents(userId) {
  const allSms = await userhierarchy(userId);
  $("#aSbox").empty().append(`<option>${_t('Zgjidh')}</option>`);
  allSms.forEach((sm) => {
    $("#aSbox").append(`<option value="${sm.id}"> 
       ${sm.username}   
 </option>`);
  });

  $("#jackpoUser").empty().append(`<option>${_t('Zgjidh')}</option>`);
}

export default Jackpot;
